import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=62c055f7&scoped=true"
import script from "./MainHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=62c055f7&prod&scoped=true&lang=css"
import style1 from "./MainHeader.vue?vue&type=style&index=1&id=62c055f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c055f7",
  null
  
)

export default component.exports